import styled from 'styled-components';
import {palette} from 'styled-theme';
import {borderRadius, boxShadow, transition} from '../../settings/style-util';

const TopbarDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 360px;
  min-width: 160px;
  margin: -12px -16px;
  background-color: #fff;
  ${borderRadius('5px')};
  ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
  ${transition()};

  @media only screen and (width <= 767px) {
    width: 310px;
  }

  .link {
    display: flex;
    justify-content: flex-start;
    padding: 8px 15px;
    font-size: 13px;
    line-height: 1.1;
    color: ${palette('text', 1)};
    text-decoration: none;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    ${transition()};

    &:hover {
      background-color: ${palette('secondary', 6)};
    }
    
    .anticon {
      padding-right: 8px;
    }
  }

  .divider {
    display: flex;
    height: 1px;
    margin: 4px 0;
    background: ${palette('grayscale', 3)};
  }

  .isoDropdownHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 15px 30px;
    margin-bottom: 0;
    border-bottom: 1px solid #f1f1f1;

    h3 {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: ${palette('text', 0)};
      text-align: center;
      text-transform: uppercase;
    }
  }

  .isoDropdownBody {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 300px;
    margin-bottom: 10px;
    background-color: ${palette('grayscale', 6)};

    a {
      text-decoration: none;
    }

    .isoDropdownListItem {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      width: 100%;
      padding: 15px 30px;
      text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      text-decoration: none;
      border-bottom: 1px solid ${palette('border', 2)};
      ${transition()};

      &:hover {
        background-color: ${palette('grayscale', 3)};
      }

      .isoListHead {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
      }

      h5 {
        margin-top: 0;
        font-size: 13px;
        font-weight: 500;
        color: ${palette('text', 0)};
      }

      p {
        overflow: hidden;
        font-size: 12px;
        font-weight: 400;
        color: ${palette('text', 2)};
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .isoDate {
        flex-shrink: 0;
        font-size: 11px;
        color: ${palette('grayscale', 1)};
      }
    }
  }

  .isoViewAllBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px 20px;
    font-size: 13px;
    font-weight: 500;
    color: ${palette('text', 2)};
    text-align: center;
    text-decoration: none;
    ${transition()};


    &:hover {
      color: ${palette('primary', 0)};
    }
  }

  .isoDropdownFooterLinks {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px 20px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      font-size: 13px;
      font-weight: 500;
      line-height: 1;
      color: ${palette('text', 0)};
      text-decoration: none;
      border: 1px solid ${palette('border', 1)};
      ${transition()};

      &:hover {
        color: #fff;
        background-color: ${palette('primary', 0)};
        border-color: ${palette('primary', 0)};
      }
    }

    h3 {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.3;
      color: ${palette('text', 0)};
    }
  }

  &.withImg {
    /* stylelint-disable-next-line no-descending-specificity */
    .isoDropdownListItem {
      display: flex;
      flex-direction: row;

      .isoImgWrapper {
        display: -ms-inline-flex;
        display: inline-flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 35px;
        height: 35px;
        margin: ${props => (props['data-rtl'] === 'rtl' ? '0 0 0 15px' : '0 15px 0 0')};
        overflow: hidden;
        background-color: ${palette('grayscale', 9)};
        ${borderRadius('50%')};

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .isoListContent {
        display: flex;
        flex-direction: column;
        width: 100%;

        .isoListHead {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        h5 {
          padding: ${props => (props['data-rtl'] === 'rtl' ? '0 0 0 15px' : '0 15px 0 0')};
          margin-bottom: 0;
        }

        .isoDate {
          flex-shrink: 0;
          font-size: 11px;
          color: ${palette('grayscale', 1)};
        }

        p {
          line-height: 1.5;
          white-space: normal;
        }
      }
    }
  }

  &.quickAdd {
    width: 180px;
    padding: 7px 0;
  }

  &.notification {
    @media only screen and (width <= 575px) {
      width: 275px;
    }
  }

  &.user {
    width: 180px;
    padding: 7px 0;
  }

  .topbar__language-menu-down-icon {
    display: flex;
    align-items: center;
    font-size: 10px;
  }

  .ant-menu-item.topbar__language-menu-item {
    height: 28px;
    padding: 7px 15px;
    margin: 1px 4.5px;
    font-size: 12.5px;
    line-height: 1.15;
    color: #595959;
    user-select: none;
    border-radius: 4px;

    .ant-menu-title-content {
      margin-left: 22px;
    }

    &.ant-menu-item-selected {
      color: #1890ff;
    }

    &:hover {
      background: #f5f5f5;
    }
  }
`;

export default TopbarDropdownWrapper;
